import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Mail, Clock, Crown, Trash2 } from 'lucide-react';
import { AdminUserMiniCard } from './AdminUserMiniCard';
import { formatDate } from './adminHelpers';

export const AdminExpandedSections = ({
  expandedSection, pendingInvites, activeTrialUsers, subscribedUsers,
  isSuperAdmin, canModifyUser, onRevokeInvite, onExtend, onDelete
}) => (
  <>
    {expandedSection === 'pending' && pendingInvites.length > 0 && (
      <Card className="bg-slate-800 border-amber-500/30">
        <CardHeader className="pb-3">
          <CardTitle className="text-white text-base sm:text-lg flex items-center gap-2">
            <Mail className="h-4 w-4 text-amber-400" />
            Pending Invitations ({pendingInvites.length})
          </CardTitle>
        </CardHeader>
        <CardContent className="p-0">
          <div className="divide-y divide-slate-700">
            {pendingInvites.map((invite) => (
              <div key={invite.email} className="flex items-center justify-between p-3 sm:p-4" data-testid={`invite-row-${invite.email}`}>
                <div className="min-w-0">
                  <p className="text-white text-sm truncate">{invite.email}</p>
                  {invite.name && <p className="text-slate-500 text-xs">{invite.name}</p>}
                  <p className="text-slate-600 text-[10px] mt-0.5">Invited {formatDate(invite.invited_at)}</p>
                </div>
                <Button variant="ghost" size="sm" onClick={(e) => { e.stopPropagation(); onRevokeInvite(invite.email); }}
                  className="text-red-400 hover:text-red-300 hover:bg-red-500/10 flex-shrink-0"
                  data-testid={`revoke-invite-${invite.email}`}>
                  <Trash2 className="h-4 w-4" />
                </Button>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    )}

    {expandedSection === 'trials' && activeTrialUsers.length > 0 && (
      <Card className="bg-slate-800 border-emerald-500/30">
        <CardHeader className="pb-3">
          <CardTitle className="text-white text-base sm:text-lg flex items-center gap-2">
            <Clock className="h-4 w-4 text-emerald-400" />
            Active Trials ({activeTrialUsers.length})
          </CardTitle>
        </CardHeader>
        <CardContent className="p-0">
          <div className="divide-y divide-slate-700">
            {activeTrialUsers.map((u) => (
              <AdminUserMiniCard key={u.id} u={u} canModify={canModifyUser(u)} isSuperAdmin={isSuperAdmin}
                onExtend={() => onExtend(u.id)} onDelete={() => onDelete(u.id)} />
            ))}
          </div>
        </CardContent>
      </Card>
    )}

    {expandedSection === 'subscribed' && subscribedUsers.length > 0 && (
      <Card className="bg-slate-800 border-blue-500/30">
        <CardHeader className="pb-3">
          <CardTitle className="text-white text-base sm:text-lg flex items-center gap-2">
            <Crown className="h-4 w-4 text-blue-400" />
            Subscribed Users ({subscribedUsers.length})
          </CardTitle>
        </CardHeader>
        <CardContent className="p-0">
          <div className="divide-y divide-slate-700">
            {subscribedUsers.map((u) => (
              <AdminUserMiniCard key={u.id} u={u} canModify={canModifyUser(u)} isSuperAdmin={isSuperAdmin}
                onExtend={() => onExtend(u.id)} onDelete={() => onDelete(u.id)} />
            ))}
          </div>
        </CardContent>
      </Card>
    )}
  </>
);
